import { Button } from "react-admin";
import ContentAdd from '@material-ui/icons/Add';

const DialogCreate = ({ onClick }) => {
    return <Button variant="contained" label="ra.action.create" onClick={(e) => {
        e.stopPropagation();
        onClick({});
    }}><ContentAdd /></Button>
};

export default DialogCreate;